module.exports = __webpack_public_path__ + "img/marker.5c56535b.png";